import React from "react";

/**
 * HQ monogram — the Alias HQ brand mark.
 * Simple rounded square containing "HQ", scales cleanly at every size.
 */
export default function HQMark({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={className}
      aria-label="Alias HQ"
      role="img"
    >
      <rect width="512" height="512" rx="102" ry="102" fill="currentColor" fillOpacity="0.1" stroke="currentColor" strokeOpacity="0.25" strokeWidth="8" />
      <text
        x="256"
        y="256"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="'Manrope','IBM Plex Sans',-apple-system,BlinkMacSystemFont,sans-serif"
        fontWeight="800"
        fontSize="230"
        letterSpacing="-8"
        fill="currentColor"
      >HQ</text>
    </svg>
  );
}
